"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireWildcard(require("react"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      title = _ref.title,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'left' : _ref$position,
      offset = _ref.offset,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["children", "title", "position", "offset", "className"]);
  var theme = (0, _ThemeProvider.useTheme)();
  var classes = useStyles({
    theme: theme,
    props: {
      position: position,
      offset: offset
    }
  });

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var onMouseEnter = function onMouseEnter() {
    return setOpen(true);
  };

  var onMouseLeave = function onMouseLeave() {
    return setOpen(false);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    className: classes.Tooltip
  }, open && /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({
    className: (0, _classnames["default"])(classes.TooltipTitle, className)
  }, rest), title), children);
};

exports["default"] = Tooltip;
//# sourceMappingURL=index.js.map